// 隱私政策內容（4 語言）
// zh-tw 為原版（1.0 線上），zh-hk 與 zh-tw 一致；zh-cn 為簡體；en 為英文翻譯。

const zhTW = `
<h6>引言</h6>
<p>iPastBook 重視使用者的隱私。您在使用我們的服務時，我們可能會收集和使用您的相關資訊。我們希望通過本《隱私政策》向您說明，在使用我們的服務時，我們如何收集、使用、儲存和分享這些資訊，以及我們為您提供的訪問、更新、控制和保護這些資訊的方式。</p>
<p>本《隱私政策》與您所使用的 iPastBook 服務息息相關，希望您仔細閱讀，在需要時，按照本《隱私政策》的指引，作出您認為適當的選擇。本《隱私政策》中涉及的相關技術詞匯，我們盡量以簡明扼要的表述，並提供進一步說明的連結，以便您的理解。</p>
<p class="text-primary">您使用或繼續使用我們的服務，即意味著同意我們按照本《隱私政策》收集、使用、儲存和分享您的相關資訊。</p>
<p>如對本《隱私政策》或相關事宜有任何問題，請通過 <a href="https://ipastbook.com">https://ipastbook.com</a> 與我們聯繫。</p>

<h6>我們可能收集的資訊</h6>
<p>我們提供服務時，可能會收集、儲存和使用下列與您有關的資訊。如果您不提供相關資訊，可能無法註冊成為我們的使用者或無法享受我們提供的某些服務，或者無法達到相關服務擬達到的效果。</p>
<p class="text-primary">您使用服務時我們可能收集如下資訊：</p>
<ol>
  <li>個人社交賬號基礎資訊，包括 Facebook 等賬號的暱稱、頭像、所在城市、性別、個人主頁等（當您登入 iPastBook 網站，即同意 Facebook 賬戶授權 iPastBook 獲取此類資訊）；</li>
  <li>電子書排版所需的素材，包括在 Facebook 社交賬號發布的圖片、文字和視訊等（當您開始製作 Facebook 書，即同意 iPastBook 獲取此類資訊）；</li>
  <li>在 iPastBook 網站（https://ipastbook.com/）和 APP 中補充上傳的圖片和文字；</li>
  <li>收貨資訊，包括收貨人姓名、電話和收貨地址（僅在購買紙質書的時候收集，不支援刪除已發貨訂單的相關資訊）。</li>
</ol>

<h6>我們可能如何使用資訊</h6>
<p class="text-primary">我們可能將在向您提供服務的過程之中所收集的資訊用作下列用途：</p>
<ol>
  <li>向您提供電子書排版服務；</li>
  <li>向您提供紙質書印刷、寄送服務；</li>
  <li>幫助我們設計新服務，改善我們現有服務；</li>
  <li>讓您參與有關我們產品和服務的調查。</li>
</ol>
<p>為了讓您有更好的體驗、改善我們的服務或您同意的其他用途，在符合相關法律法規的前提下，我們可能將通過某一項服務所收集的資訊，以匯集資訊或者個性化的方式，用於我們的其他服務。例如，在您使用我們的一項服務時所收集的資訊，可能在另一服務中用於向您提供特定內容，或向您展示與您相關的、非普遍推送的資訊。如果我們在相關服務中提供了相應選項，您也可以授權我們將該服務所提供和儲存的資訊用於我們的其他服務。</p>

<h6>如何刪除數據</h6>
<p class="text-primary">您可以通過以下步驟刪除我們收集到的資訊：</p>
<ol>
  <li>打開我們的官方 Messenger 鏈接 <a href="https://m.me/iPastBookBot">m.me/iPastBookBot</a>；</li>
  <li>向我們發送「刪除我的資訊」。</li>
</ol>
<p>我們的工作人員會在第一時間刪除我們收集到的與您有關的資訊。</p>

<h6>我們可能分享的資訊</h6>
<p>除以下情形外，<span class="text-primary">未經您同意</span>，我們以及我們的關聯公司不會與任何第三方分享您的個人資訊：</p>
<ol>
  <li>
    我們以及我們的關聯公司，可能將您的個人資訊與我們的關聯公司、合作夥伴及第三方服務供應商、承包商及代理（例如代表我們印製紙質書的印刷服務提供商、為我們提供快遞業務的物流供應商）分享，用作下列用途：
    <ol>
      <li>向您提供我們的服務；</li>
      <li>實現「我們可能如何使用資訊」部分所述目的；</li>
      <li>履行我們在本《隱私政策》中的義務和行使我們的權利；</li>
      <li>理解、維護和改善我們的服務。</li>
    </ol>
  </li>
  <li>隨著我們業務的持續發展，我們以及我們的關聯公司有可能進行合併、收購、資產轉讓或類似的交易，您的個人資訊有可能作為此類交易的一部分而被轉移。我們將在轉移前通知您。</li>
  <li>
    我們或我們的關聯公司還可能為以下需要而保留、儲存或披露您的個人資訊：
    <ol>
      <li>遵守適用的法律法規；</li>
      <li>遵守法院命令或其他法律程式的規定；</li>
      <li>遵守相關政府機關的要求；</li>
      <li>為遵守適用的法律法規、維護社會公共利益，或保護我們的客戶、我們或我們的集團公司、其他使用者或僱員的人身和財產安全或合法權益所合理必需的用途。</li>
    </ol>
  </li>
</ol>

<h6>隱私政策的適用例外</h6>
<p>就下列相關事宜的發生，iPastBook 不承擔任何法律責任：</p>
<ol>
  <li>由於個人未按要求校對電子書內容，導致的任何與實物預期不符的情況；</li>
  <li>本隱私協議並不適用於任何第三方提供的服務或第三方的資訊使用規則，我們對任何第三方使用由您提供的資訊不承擔任何責任，例如快遞丟件；</li>
  <li>由於您將移動裝置交予他人使用或主動分享，導致的任何個人資訊的洩露，或其他非因 iPastBook 原因導致的個人資訊的洩露；</li>
  <li>由於技術的限制以及可能存在的各種惡意手段，在網際網路行業，即便竭盡所能加強安全措施，也不可能始終保證資訊百分之百的安全。您需要了解，您接入我們的服務所用的系統和通訊網路，有可能因我們可控範圍外的因素而出現問題；</li>
  <li>iPastBook 在各服務條款及聲明中列明的使用方式或免責情形。</li>
</ol>

<h6>變更</h6>
<p>我們可能適時修訂本《隱私政策》的條款，該等修訂構成本《隱私政策》的一部分。如該等修訂造成您在本《隱私政策》下權利的實質減少，我們將在修訂生效前通過在主頁上顯著位置提示或以其他方式通知您。在該種情況下，若您繼續使用我們的服務，即表示同意受經修訂的本《隱私政策》的約束。</p>
`

const zhCN = `
<h6>引言</h6>
<p>iPastBook 重视使用者的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。</p>
<p>本《隐私政策》与您所使用的 iPastBook 服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。</p>
<p class="text-primary">您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。</p>
<p>如对本《隐私政策》或相关事宜有任何问题，请通过 <a href="https://ipastbook.com">https://ipastbook.com</a> 与我们联系。</p>

<h6>我们可能收集的信息</h6>
<p>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的使用者或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p>
<p class="text-primary">您使用服务时我们可能收集如下信息：</p>
<ol>
  <li>个人社交账号基础信息，包括 Facebook 等账号的昵称、头像、所在城市、性别、个人主页等（当您登入 iPastBook 网站，即同意 Facebook 账户授权 iPastBook 获取此类信息）；</li>
  <li>电子书排版所需的素材，包括在 Facebook 社交账号发布的图片、文字和视频等（当您开始制作 Facebook 书，即同意 iPastBook 获取此类信息）；</li>
  <li>在 iPastBook 网站（https://ipastbook.com/）和 APP 中补充上传的图片和文字；</li>
  <li>收货信息，包括收货人姓名、电话和收货地址（仅在购买纸质书的时候收集，不支持删除已发货订单的相关信息）。</li>
</ol>

<h6>我们可能如何使用信息</h6>
<p class="text-primary">我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p>
<ol>
  <li>向您提供电子书排版服务；</li>
  <li>向您提供纸质书印刷、寄送服务；</li>
  <li>帮助我们设计新服务，改善我们现有服务；</li>
  <li>让您参与有关我们产品和服务的调查。</li>
</ol>
<p>为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。</p>

<h6>如何删除数据</h6>
<p class="text-primary">您可以通过以下步骤删除我们收集到的信息：</p>
<ol>
  <li>打开我们的官方 Messenger 链接 <a href="https://m.me/iPastBookBot">m.me/iPastBookBot</a>；</li>
  <li>向我们发送"删除我的信息"。</li>
</ol>
<p>我们的工作人员会在第一时间删除我们收集到的与您有关的信息。</p>

<h6>我们可能分享的信息</h6>
<p>除以下情形外，<span class="text-primary">未经您同意</span>，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p>
<ol>
  <li>
    我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们印制纸质书的印刷服务提供商、为我们提供快递业务的物流供应商）分享，用作下列用途：
    <ol>
      <li>向您提供我们的服务；</li>
      <li>实现"我们可能如何使用信息"部分所述目的；</li>
      <li>履行我们在本《隐私政策》中的义务和行使我们的权利；</li>
      <li>理解、维护和改善我们的服务。</li>
    </ol>
  </li>
  <li>随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</li>
  <li>
    我们或我们的关联公司还可能为以下需要而保留、储存或披露您的个人信息：
    <ol>
      <li>遵守适用的法律法规；</li>
      <li>遵守法院命令或其他法律程序的规定；</li>
      <li>遵守相关政府机关的要求；</li>
      <li>为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他使用者或雇员的人身和财产安全或合法权益所合理必需的用途。</li>
    </ol>
  </li>
</ol>

<h6>隐私政策的适用例外</h6>
<p>就下列相关事宜的发生，iPastBook 不承担任何法律责任：</p>
<ol>
  <li>由于个人未按要求校对电子书内容，导致的任何与实物预期不符的情况；</li>
  <li>本隐私协议并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任，例如快递丢件；</li>
  <li>由于您将移动设备交予他人使用或主动分享，导致的任何个人信息的泄露，或其他非因 iPastBook 原因导致的个人信息的泄露；</li>
  <li>由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题；</li>
  <li>iPastBook 在各服务条款及声明中列明的使用方式或免责情形。</li>
</ol>

<h6>变更</h6>
<p>我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。</p>
`

const en = `
<h6>Introduction</h6>
<p>iPastBook values your privacy. We may collect and use information about you when you use our services. This Privacy Policy explains how we collect, use, store, and share that information, and how you can access, update, control, and protect it.</p>
<p>Please read this Privacy Policy carefully and follow its guidance to make choices appropriate for you.</p>
<p class="text-primary">By using or continuing to use our services, you agree that we may collect, use, store, and share your information in accordance with this Privacy Policy.</p>
<p>If you have any questions about this Privacy Policy, please contact us at <a href="https://ipastbook.com">https://ipastbook.com</a>.</p>

<h6>Information We May Collect</h6>
<p>To provide our services, we may collect, store, and use the following information about you. If you do not provide this information, you may be unable to register or use some of our services.</p>
<p class="text-primary">We may collect the following when you use our services:</p>
<ol>
  <li>Basic social account information, including your nickname, avatar, city, gender, and profile page on Facebook and similar platforms (you authorize iPastBook to obtain this information when you log in via these platforms);</li>
  <li>Materials needed to typeset your book, including images, text, and videos posted on your social account (you authorize iPastBook to obtain this when you begin creating a book);</li>
  <li>Photos and text you upload directly on the iPastBook website (https://ipastbook.com/) or app;</li>
  <li>Shipping information, including recipient name, phone number, and shipping address (collected only when you purchase a printed book; information for shipped orders cannot be deleted).</li>
</ol>

<h6>How We May Use Information</h6>
<p class="text-primary">We may use information collected while providing services for the following purposes:</p>
<ol>
  <li>To provide e-book typesetting services;</li>
  <li>To provide printing and shipping of printed books;</li>
  <li>To help us design new services and improve existing ones;</li>
  <li>To invite you to participate in surveys about our products and services.</li>
</ol>
<p>To improve your experience and our services, where permitted by law we may use information collected through one service in aggregated or personalized form across our other services.</p>

<h6>How to Delete Your Data</h6>
<p class="text-primary">You can delete information we have collected by following these steps:</p>
<ol>
  <li>Open our official Messenger link <a href="https://m.me/iPastBookBot">m.me/iPastBookBot</a>;</li>
  <li>Send us the message "Delete my information".</li>
</ol>
<p>Our team will delete the information we have collected about you as soon as possible.</p>

<h6>Information We May Share</h6>
<p>Except in the following situations, <span class="text-primary">we and our affiliates will not share your personal information with any third party without your consent</span>:</p>
<ol>
  <li>
    We and our affiliates may share your personal information with affiliates, partners, and third-party service providers, contractors, and agents (for example, printing providers and logistics providers shipping your book), for the following purposes:
    <ol>
      <li>To provide our services to you;</li>
      <li>To fulfill the purposes described in "How We May Use Information";</li>
      <li>To perform our obligations and exercise our rights under this Privacy Policy;</li>
      <li>To understand, maintain, and improve our services.</li>
    </ol>
  </li>
  <li>As our business evolves, we or our affiliates may engage in mergers, acquisitions, asset transfers, or similar transactions, and your personal information may be transferred as part of such transactions. We will notify you before any such transfer.</li>
  <li>
    We or our affiliates may also retain, store, or disclose your personal information when reasonably necessary to:
    <ol>
      <li>Comply with applicable laws and regulations;</li>
      <li>Comply with court orders or other legal procedures;</li>
      <li>Comply with requirements of relevant government authorities;</li>
      <li>Protect the safety, rights, or property of our customers, our group companies, other users, employees, or the public.</li>
    </ol>
  </li>
</ol>

<h6>Exceptions to This Privacy Policy</h6>
<p>iPastBook accepts no legal liability for the following:</p>
<ol>
  <li>Any discrepancy between the printed book and your expectations caused by your failure to proofread the e-book content;</li>
  <li>Any third-party service or third-party information practices — we are not responsible for third parties' use of information you provide (e.g., loss of parcels by couriers);</li>
  <li>Any disclosure of personal information caused by you sharing your device with others, or other causes outside iPastBook's control;</li>
  <li>Despite our best security efforts, no internet service can guarantee 100% security. The systems and networks used to access our services may experience issues outside our control;</li>
  <li>Other usage methods or disclaimers set out in iPastBook's various terms of service and notices.</li>
</ol>

<h6>Changes</h6>
<p>We may update this Privacy Policy from time to time. Such updates form part of this Privacy Policy. If a change materially reduces your rights under this Privacy Policy, we will notify you prominently before the change takes effect. Continuing to use our services after the change means you agree to be bound by the updated Privacy Policy.</p>
`

export default {
  'zh-tw': zhTW,
  'zh-hk': zhTW,
  'zh-cn': zhCN,
  en
}
